import { dayjs } from '@mobi/utils/date'
import type { StructuredSearchResult } from '@core/Areas/StructuredSearch/types'

export function getRedirectUrl(searchResult: StructuredSearchResult): string {
  let url = ''

  const acceptorResult = searchResult as StructuredSearchResult
  const formattedDate = dayjs(acceptorResult.acceptor.race.fixture.date).format('YYYY-MM-DD')

  url = `/tote/meetings/${acceptorResult.acceptor.race.fixture.id}/${acceptorResult.acceptor.race.number}?date=${formattedDate}`

  return url
}
